<route>
{
    "name": "auth-login",
    "meta": {
        "title": "Autentificare",
        "permissions": ["guest"],
        "fail": "/403"
    }
}
</route>
<template>
  <modal-layout class="white">
    <v-card :flat="true">
      <v-toolbar class="primary">
        <v-btn
          icon
          color="white"
          @click.native="redirectBack()"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title class="text-xs-center white--text">
            AutoVolan CRM
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <!-- If There is no User Account Login Yet Redirect to Authentication Page -->
          <v-btn
            color="success"
            @click.native="goHome()"
          >
            <v-icon>fa-home</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="padding-top:150px;">
        <v-container fluid>
          <form @submit.prevent="login()">
            <v-layout row>
              <v-flex
                xs12
                sm12
                md4
                offset-md4
                lg4
                offset-lg4
                xl4
                offset-xl4
              >
                <v-text-field
                  :disabled="isX509"
                  v-model="form.username"
                  v-validate="'required|email'"
                  :error-messages="errorMessages('username')"
                  :class="{ 'error--text': hasErrors('username') }"
                  label="Nume utilizator sau e-mail"
                  class="primary--text"
                  name="username"
                  data-vv-name="username"
                  prepend-icon="email"
                  counter="255"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex
                xs12
                sm12
                md4
                offset-md4
                lg4
                offset-lg4
                xl4
                offset-xl4
              >
                <v-text-field
                  v-model="form.password"
                  v-validate="'required|min:8'"
                  :append-icon="icon"
                  :type="!password_visible ? 'password' : 'text'"
                  :error-messages="errorMessages('password')"
                  :class="{ 'error--text': hasErrors('password') }"
                  label="Parola"
                  class="primary--text"
                  name="password"
                  data-vv-name="password"
                  counter="255"
                  prepend-icon="fa-key"
                  @click:append="() => (password_visible = !password_visible)"
                />
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              sm12
              md4
              offset-md4
              lg4
              offset-lg4
              xl4
              offset-xl4
              text-xs-center
              class="px-2"
            >
              <v-btn
                :loading="form.busy"
                :disabled="errors.any()"
                block
                type="submit"
                color="primary"
              >
                  Autentificare
                <v-icon right>
                  fa-sign-in
                </v-icon>
              </v-btn>
            </v-flex>
          </form>
          <v-layout
            row
            wrap
            my-3
          >
            <v-flex
              xs6
              md2
              offset-md4
              class="px-2"
            >
              <v-btn
                dark
                block
                color="secondary"
                :disabled="!enableAdminRegister"
                @click.native="goToRegister()"
              >
                  Inregistrare
              </v-btn>
            </v-flex>
            <v-flex
              xs6
              md2
              class="px-2"
            >
              <v-btn
                dark
                block
                color="error"
                @click.native="resetPassword()"
              >
                  Recuperare parola
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </modal-layout>
</template>

<script>
import ModalLayout from "Layouts/ModalLayout.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("auth");
import validationError from "Mixins/validation-error";
import { Form } from "vform";

export default {
  components: {
    ModalLayout
  },
  mixins: [validationError],
  data: () => ({
    form: new Form({
      username: "",
      email: "",
      password: "",
      remember: false
    }),
    password_visible: false,
    enableAdminRegister: false,
    isX509: false
  }),
  computed: {
    icon() {
      return this.password_visible ? "visibility" : "visibility_off";
    },
    ...mapState({
      isAuthenticated: "isAuthenticated"
    })
  },
  mounted() {
    let self = this;
    /* Make Sure We Only Load Login Page If Not Authenticated */
    if (self.isAuthenticated) {
      /* nextick make sure our modal wount be visible before redirect */
      return self.$nextTick(() => self.$router.go(-1));
    }
    var x509AuthEmail = this.$cookies.get('x509Auth')
    console.log(x509AuthEmail)
    if (!this._.isNil(x509AuthEmail)) {
      this.isX509 = true
      this.form.username = x509AuthEmail
    }
    this.enableAdminRegister = this.Static?.enableAdminRegister
  },
  methods: {
    resetPassword() {
      let self = this;
      self.$nextTick(() => self.$router.push({ name: "auth-forgot-password" }));
    },
    goHome() {
      let self = this;
      self.$nextTick(() => self.$router.push({ name: "index" }));
    },
    goToRegister() {
      let self = this;
      self.$nextTick(() => self.$router.push({ name: "auth-register" }));
    },
    redirectBack() {
      let self = this;
      return self.$nextTick(() => self.$router.go(-1));
    },
    login() {
      let self = this;
      self.$validator.validateAll();
      if (!self.errors.any()) {
        self.submit(self.form);
      }
    },
    ...mapActions({
      submit: "login"
    })
  }
};
</script>
